'use client';

import { createContext, useContext } from 'react';
import type { TemplateBulkImportQueueItem } from '../types/template-bulk-import-queue-item';
export interface TemplateBulkImportContextValue {
  queue: TemplateBulkImportQueueItem[];
  sectionCollapsed: boolean;
  setSectionCollapsed: (collapsed: boolean) => void;
  startImportFromFiles: (filesWithPaths: Array<{
    file: File;
    relativePath: string;
    parentSpaceNodeId: string;
  }>, rootNodeId: string) => Promise<void>;
  retryItem: (clientId: string) => void;
  hasActiveWork: boolean;
}
export const TemplateBulkImportContext = createContext<TemplateBulkImportContextValue | null>(null);
export function useTemplateBulkImport(): TemplateBulkImportContextValue {
  const ctx = useContext(TemplateBulkImportContext);
  if (!ctx) {
    throw new Error('useTemplateBulkImport must be used within TemplateBulkImportProvider');
  }
  return ctx;
}